import api from '../../interceptorServices';
import { onsite_url } from '../../../config';

const versionUrl = onsite_url + 'api/onsite/presentationVersion';

/* ─────────────────────────────────────────────────────────────────
   GET — fetch all versions
───────────────────────────────────────────────────────────────── */
export const getData = async () => {
  const response = await api.get(versionUrl);
  return response.data.data;
};

/* ─────────────────────────────────────────────────────────────────
   POST — three cases handled by definePost controller:
     Case 1: { id }                         → fetch single by PK
     Case 2: { presentation_uuid, field }   → fetch filtered list
     Case 3: { id: "", presentation_uuid,
               field, content, saved_by }   → create new snapshot
───────────────────────────────────────────────────────────────── */
export const addData = async (data) => {
  const response = await api.post(versionUrl, data);
  return response.data;
};

/* ─────────────────────────────────────────────────────────────────
   PUT — update version by ID
───────────────────────────────────────────────────────────────── */
export const updateData = async (data) => {
  const response = await api.put(versionUrl, data);
  return response.data;
};

/* ─────────────────────────────────────────────────────────────────
   DELETE — delete version by ID
───────────────────────────────────────────────────────────────── */
export const deleteData = async (data) => {
  const response = await api.delete(versionUrl, {
    data: { id: data.id },
  });
  return response.data;
};